import { render, staticRenderFns } from "./LecturesMenu.vue?vue&type=template&id=249536cb&"
import script from "./LecturesMenu.vue?vue&type=script&lang=js&"
export * from "./LecturesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports